import { render, staticRenderFns } from "./YandexShare.vue?vue&type=template&id=11d7756a&"
import script from "./YandexShare.vue?vue&type=script&lang=js&"
export * from "./YandexShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports